import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import esriConfig from '@arcgis/core/config';
import { uofuMapComponentsTheme } from '@uofu-uss-gis/ui-react';
import App from './App';
import { env } from './config/env';
import './index.css';
import '@uofu-uss-gis/ui-react/styles.css';
import '@arcgis/core/assets/esri/themes/light/main.css';

const arcgisApiKey = env.arcgisApiKey;
if (arcgisApiKey) {
  esriConfig.apiKey = arcgisApiKey;
}

// StrictMode disabled to prevent double execution of OIDC callback
// The global flag in CallbackHandler prevents double execution as a backup
ReactDOM.createRoot(document.getElementById('root')!).render(
  <ThemeProvider theme={uofuMapComponentsTheme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);
